<script>
    // Logic 
    import {getCases, getSUS } from "../../utils/apiNew";
    import {format, parseISO} from 'date-fns';
	import {timeParse} from "d3-time-format";



    // Components 
    import MultiLine from './components/MultiLine.svelte';

    // Bindings 
    const susPromise = getSUS();
    const casesPromise = getCases();
    const promises = Promise.all([susPromise, casesPromise])
    
    let xKey = "date";
    let yKey = "value";
    let zKey = "label";
    const parseDate = timeParse("%Y-%m-%d");
    const seriesNames = ['hospitalized', 'respirator', 'cases'];

  
    
    const flattenAndGrouped = (data) => {
        let fullList = [];
        
        const casesList = data[1].all.slice(-data[0].all.length);
        
        casesList.forEach (e => {
            fullList[e[0]] = {...fullList[e[0]] || []};
            fullList[e[0]].cases = e[1];
        });

        data[0].all.forEach(e => {
            const date = format(new Date(e.imported), 'yyyy-MM-dd');
            fullList[date] = {...fullList[date] || []};
            fullList[date].hospitalized = e.hospitalized;
            
        })

        data[0].all.forEach(e => {
            const date = format(new Date(e.imported), 'yyyy-MM-dd');
            fullList[date] = {...fullList[date] || []};
            fullList[date].respirator = e.respirator;    
        })
        const dataLong = seriesNames.map(key => {
            return {
                [zKey]: key,
                values: Object.entries(fullList).map(d => {
                    d[0] = typeof d[0] === 'string' ? parseDate(d[0]) : d[0]; // Conditional required for sapper
                    return {
                        [yKey]: +d[1][key],
                        [xKey]: d[0]
                    };
                })
            };
        });
        return {dataLong, data:Object.entries(fullList)};
    }




	

</script>

<div> 
    {#await promises}
    <p>Laster ...</p>
    {:then data} 
        <MultiLine dataLong={flattenAndGrouped(data).dataLong} data={flattenAndGrouped(data).data} {seriesNames}/>
    {/await}
</div> 


<style lang="scss">
</style>